<script setup lang="ts">
import {onBeforeMount, ref} from "vue";

const showMenu = ref(false),
    topOfPage= ref(true);
const toggleNav = () => (showMenu.value = !showMenu.value);

const handleScroll = () => {
    if (window.scrollY > 10) {
        topOfPage.value = false;
    } else {
        topOfPage.value = true;
    }
}

onBeforeMount(() => window.addEventListener('scroll', handleScroll))
</script>

<template>
    <div class="">
        <nav
            :class="[showMenu ? 'open bg-kozel-sandy' : 'bg-transparent', topOfPage ? '' : 'onScroll pb-4']"
            class="px-6 pt-4 w-full"
        >
            <div class="flex items-center justify-between relative">
                <a href="#" @click="toggleNav">
                    <img src="@/assets/images/kozel.webp" width="120px" alt="Kozel" class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                </a>
                <div @click="toggleNav" class="flex">
                    <div id="nav-icon" :class="showMenu ? 'open' : ''">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>

            <ul :class="showMenu ? 'open p-4' : ''"
                class="absolute flex-col mt-0 space-y-4
                    text-2xl text-center
                    transition-all duration-500
                    left-0 w-full bg-kozel-sandy text-kozel-brown">
                <li><a href="#rules" @click="toggleNav">Zasady</a></li>
                <li><a href="#prizes" @click="toggleNav">Do wygrania</a></li>
                <li><a href="#submission" @click="toggleNav">Weź udział</a></li>
                <li><a href="#regulations" @click="toggleNav">Regulamin</a></li>
                <li><a href="#contact" @click="toggleNav">Kontakt</a></li>
            </ul>
        </nav>
    </div>
</template>

<style scoped>
ul.open {
    max-height:650px;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
}

ul {
    overflow: hidden;
    max-height: 0;

}

nav.open {
    transition: background-color 0s ease-in;
}

nav {
    transition: background-color 0.2s ease-out 0.4s;
}

#nav-icon {
    width: 30px;
    height: 35px;
    position: relative;
    margin: 10px auto;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
}

#nav-icon span {
    display: block;
    position: absolute;
    height: 5px;
    width: 100%;
    background: var(--color-kozel-brown);
    border-radius: 9px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
}

#nav-icon span:nth-child(1) {
    top: 8px;
}

#nav-icon span:nth-child(2),#nav-icon span:nth-child(3) {
    top: 18px;
}

#nav-icon.open span:nth-child(1) {
    top: 9px;
    width: 0%;
    left: 50%;
}

#nav-icon.open span:nth-child(2) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
}

#nav-icon.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
}

#nav-icon.open span:nth-child(2), #nav-icon.open span:nth-child(3) {
    top: 14px;
}

.onScroll {
    box-shadow: 0 0 10px var(--color-kozel-brown);
    background: var(--color-kozel-sandy);
    position: fixed;
    z-index: 10;
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
}

ul.open {
    box-shadow: 0 10px 8px -8px var(--color-kozel-brown);
}
</style>